jQuery(document).ready(function () {
  $(".feedbackSlider").each(function () {
    var sliderIdName = this.id;

    var sliderId = "#" + sliderIdName;

    $(sliderId).slick({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 500,
      fade: false,
      slidesToShow: 2,
      slidesToScroll: 2,
      cssEase: "linear",
      autoplay: true,
      autoplaySpeed: "3000",
      pauseOnHover: true,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 1,
          },
        },
      ],
    });
  });
});



// WEBPACK FOOTER //
// ./js/parts/feedbackSlider.js